import React, { useContext, useEffect, useRef, useState } from "react";
import {
  FaArrowLeft,
  FaArrowRight,
  FaCheckCircle,
  FaFastBackward,
  FaFastForward,
  FaList,
} from "react-icons/fa";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { axiosServer } from "../../../../axiosServer";
import buildLink from "../../../../urls";
import axios from "axios";
import { CompanyContext } from "../../../../contexts/companyCotext";
import MessageAlert from "../../../../components/messageAlert";
import { PlaySounds } from "../../../../functions/playSounds";
import Cookies from "js-cookie";
import { TbCircleXFilled } from "react-icons/tb";

const ScanPickUpOrderv2 = () => {
  const [usersIds, setUsersIds] = useState([]);
  const hiddenProductId = useRef(null);
  const { id } = useParams();
  const history = useNavigate();
  const [hasproductFocus, setHasproductFocus] = useState(false);
  const [hasbinFocus, setHasBinFocus] = useState(true);
  const { playErrorSound, playSuccessSound } = PlaySounds();
  const [list, setList] = useState();
  const [orederProducts, setOrderProducts] = useState(null);
  const [productsPickedd, setProductsPickedd] = useState({});
  const scannedValue = useRef();
  const [showMessgSucc, setShowMessageSucc] = useState(false);
  const [message, setMessage] = useState("");
  const [showMessgErr, setShowMessageErr] = useState(false);
  const [storeType, setStoreType] = useState(null);
  const [storeTypeVal, setStoreTypeVal] = useState(null);
  const location = useLocation();
  const [next, setNext] = useState(false);
  const [missing, setMissing] = useState(false);

  const [disable, setDisable] = useState(false);
  // Function to get query parameters
  const getQueryParams = (param) => {
    return new URLSearchParams(location.search).get(param);
  };

  const type = getQueryParams("type");

  const biggerThanTen = useRef();
  const [quantityInput, setQuantityInput] = useState();
  const [indexProduct, setindexProduct] = useState(0);
  const [counter, setCounter] = useState(0);
  const [productsPicked, setProductsPicked] = useState(0);
  const [productsNotPicked, setProductsNotPicked] = useState(0);
  const [isScannedBin, setIsScannedBin] = useState(false);

  const [splitScanProgress, setSplitScanProgress] = useState(null);

  const [show, setShow] = useState(false);

  const updateSplitScanProgress = (data = {}) => {
    const totalPackages = Number(data?.total_packages ?? 0);
    const checkedPackages = Number(data?.checked_packages ?? 0);
    const remainingPackages = Number(
      data?.remaining_packages ?? Math.max(totalPackages - checkedPackages, 0),
    );

    if (
      totalPackages === 0 &&
      checkedPackages === 0 &&
      remainingPackages === 0
    ) {
      return;
    }

    setSplitScanProgress({
      totalPackages,
      checkedPackages,
      remainingPackages,
    });
  };

  const getProductId = (product) =>
    product?.order_product_id ??
    product?.return_order_product_id ??
    product?.return_order_produdct_id;

  const buildPickedMap = (products = []) => {
    const pickedMap = {};

    products.forEach((product, index) => {
      if (product?.picked) {
        pickedMap[index] = true;
      }
    });

    return pickedMap;
  };

  const findNextUnpickedProductIndex = (pickedMap = {}, startIndex = 0) => {
    for (
      let productIndex = startIndex;
      productIndex < orederProducts.length;
      productIndex += 1
    ) {
      if (!pickedMap[productIndex]) {
        return productIndex;
      }
    }

    return -1;
  };

  const areAllProductsPicked = (pickedMap = {}) => {
    if (!orederProducts?.length) {
      return false;
    }

    return orederProducts.every(
      (product, productIndex) => pickedMap[productIndex] || product?.picked,
    );
  };

  useEffect(() => {
    if (orederProducts) {
      let numberProductPicked = 0;
      let numberProductNotPicked = 0;
      orederProducts.map((product) => {
        if (product.picked) {
          numberProductPicked += Number(product.quantity);
        } else {
          numberProductNotPicked += Number(product.quantity);
        }
      });
      setProductsPicked(numberProductPicked);
      setProductsNotPicked(numberProductNotPicked);
    }
  }, [orederProducts]);

  const searchPickupOrderProducts = async () => {
    const userID = getUserIdFromLocalStorage();
    try {
      let url = "";
      if (type == "normal") {
        url =
          buildLink("getPickupOrderProducts") +
          `&order_id=${id}` +
          `&user_id=${userID}`;
      } else {
        url =
          buildLink("getPickupReturnOrderProducts") +
          `&return_order_id=${id}` +
          `&user_id=${userID}`;
      }

      const response = await axiosServer.get(url);

      if (response.data.success) {
        const newList = response.data.data.list;
        setList(newList);

        let products = [];
        if (type == "normal") {
          products = response.data.data.order_products;
          setOrderProducts(products);
        } else {
          products = response.data.data.return_order_products;
          setOrderProducts(products);
        }

        setProductsPickedd(buildPickedMap(products));

        setUsersIds(response.data.data.stand_bypass_users);

        scannedValue.current.focus();
      }
    } catch (e) {
      console.log("error:", e);
    }
  };
  useEffect(() => {
    searchPickupOrderProducts();
  }, []);

  useEffect(() => {
    if (!scannedValue.current) return;

    scannedValue.current.value = "";

    const isPicked = productsPickedd[indexProduct];

    if (!isPicked) {
      scannedValue.current.focus();
      setHasBinFocus(true);
    } else {
      scannedValue.current.blur();
      setHasBinFocus(false);
    }

    setIsScannedBin(false);

    if (orederProducts) {
      if (orederProducts[indexProduct]?.picked_qty) {
        setCounter(parseInt(orederProducts[indexProduct]?.picked_qty, 10));
      } else {
        setCounter(0);
      }

      setMissing(orederProducts[indexProduct]?.has_missing);

      if (orederProducts[indexProduct]?.bin_id) {
        setStoreType("Bin");
        setStoreTypeVal(orederProducts[indexProduct]?.floor_name);
      } else if (orederProducts[indexProduct]?.upc) {
        setStoreType("Upc");
        setStoreTypeVal(orederProducts[indexProduct]?.upc);
      } else if (orederProducts[indexProduct]?.big_upc) {
        setStoreType("BigUpc");
        setStoreTypeVal(orederProducts[indexProduct]?.big_upc);
      }
    }
  }, [indexProduct, orederProducts, productsPickedd]);

  async function checkShelfLabel(e) {
    e.preventDefault();
    if (
      scannedValue.current.value !== "" &&
      (scannedValue.current.value == orederProducts[indexProduct]?.bin_id ||
        scannedValue.current.value == orederProducts[indexProduct]?.upc ||
        scannedValue.current.value == orederProducts[indexProduct]?.big_upc ||
        counter == orederProducts.quantity)
    ) {
      setIsScannedBin(true);
      setMessage(`Right ${storeType} for Product! Scan Product to pick it up.`);
      playSuccessSound();
      setShowMessageSucc(true);
      hiddenProductId.current.focus();
      setTimeout(() => {
        setShowMessageSucc(false);
      }, 3000);
    } else {
      setIsScannedBin(false);
      scannedValue.current.value = "";
      setMessage("Bin or Upc or BigUpc Not Correct ! ");
      playErrorSound();
      setShowMessageErr(true);
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
    }
    hiddenProductId.current.value = "";
  }

  const getUserIdFromLocalStorage = () => {
    return localStorage.getItem("userID");
  };

  async function scanProduct(e) {
    e.preventDefault();

    if (
      scannedValue.current.value == "" &&
      !usersIds.includes(getUserIdFromLocalStorage()) &&
      (scannedValue.current.value !== orederProducts[indexProduct]?.bin_id ||
        scannedValue.current.value !== orederProducts[indexProduct]?.upc)
    ) {
      playErrorSound();
      setIsScannedBin(false);
      setMessage(
        " The value of bin or upc scanned is even empty or incorrect !",
      );
      setShowMessageErr(true);
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
    } else {
      const userID = getUserIdFromLocalStorage();

      // const obj = {
      //   order_id: id,
      //   label: hiddenProductId.current.value,
      //   quantity: orederProducts[indexProduct].quantity > 10 ? biggerThanTen.current.value:orederProducts[indexProduct].quantity ,
      //   user_id: userID,
      //   upc: orederProducts[indexProduct]?.upc,
      //   scanned_stand:isScannedBin
      // };

      const obj = {
        // order_id: id,
        label: hiddenProductId.current.value,
        quantity:
          orederProducts[indexProduct].quantity > 10
            ? biggerThanTen.current.value
            : 1,
        user_id: userID,
        scanned_stand: isScannedBin,
        // Add bin_id, upc, or big_upc based on the conditions
        ...(orederProducts[indexProduct]?.bin_id
          ? { bin_id: orederProducts[indexProduct]?.bin_id }
          : orederProducts[indexProduct]?.upc
            ? { upc: orederProducts[indexProduct]?.upc }
            : orederProducts[indexProduct]?.big_upc
              ? { big_upc: orederProducts[indexProduct]?.big_upc }
              : {}),
      };
      if (type == "normal") {
        obj.order_id = id;
      } else {
        obj.return_order_id = id;
      }
      const item = hiddenProductId.current.value.trim();

      const isSplitOrderId = (item.match(/-/g) || []).length >= 2;

      if (isSplitOrderId) {
        setShow(true);
      } else {
        setShow(false);
      }
      try {
        let url = "";
        if (type == "normal") {
          url = buildLink("pickupOrderProduct");
        } else {
          url = buildLink("pickupReturnOrderProduct");
        }
        const queryParams = new URLSearchParams(obj).toString();
        await axiosServer.post(url + "&" + queryParams).then((res) => {
          hiddenProductId.current.value = "";
          const scanResults = Array.isArray(res?.data?.data)
            ? res.data.data
            : res?.data?.data
              ? [res.data.data]
              : [];

          if (isSplitOrderId) {
            updateSplitScanProgress(
              res?.data?.package_scan ?? res?.data?.data,
            );
          }

          const currentProductId = getProductId(orederProducts[indexProduct]);
          const currentScanResult =
            scanResults.find(
              (scanResult) => getProductId(scanResult) === currentProductId,
            ) ?? scanResults[0];
          const updatedPickedMap = { ...productsPickedd };

          scanResults.forEach((scanResult) => {
            if (!scanResult?.pickedup) {
              return;
            }

            orederProducts.forEach((product, productIndex) => {
              if (getProductId(scanResult) === getProductId(product)) {
                updatedPickedMap[productIndex] = true;
              }
            });
          });

          if (currentScanResult?.pickedup) {
            setProductsPickedd(updatedPickedMap);

            setIsScannedBin(false);

            setMessage("Product successfully picked up");
            playSuccessSound();
            setShowMessageSucc(true);
            setTimeout(() => {
              setShowMessageSucc(false);
            }, 3000);

            const nextProductIndex = findNextUnpickedProductIndex(
              updatedPickedMap,
              indexProduct + 1,
            );

            if (nextProductIndex !== -1) {
              setindexProduct(nextProductIndex);
            } else {
              const firstUnpickedProductIndex = findNextUnpickedProductIndex(
                updatedPickedMap,
                0,
              );

              if (firstUnpickedProductIndex !== -1) {
                setindexProduct(firstUnpickedProductIndex);
              } else if (areAllProductsPicked(updatedPickedMap)) {
                setMessage("Product successfully picked up");
                playSuccessSound();
                setShowMessageSucc(true);
                setTimeout(() => {
                  setShowMessageSucc(false);
                }, 3000);
                history(-1);
              }
            }
            if (currentScanResult.counter !== "1") {
              setProductsPicked(
                Number(productsPicked) + Number(currentScanResult.counter),
              );
              setProductsNotPicked(
                Number(productsNotPicked) - Number(currentScanResult.counter),
              );
            } else {
              setProductsPicked(Number(productsPicked) + 1);
              setProductsNotPicked(Number(productsNotPicked) - 1);
            }
          } else {
            setCounter(counter + 1);
            setProductsPicked(Number(productsPicked) + 1);
            setProductsNotPicked(Number(productsNotPicked) - 1);
          }
        });
      } catch (e) {
        // console.log('-------------------------------------------------')
        hiddenProductId.current.value = "";
        playErrorSound();
        setMessage(e.response.data.message);
        setShowMessageErr(true);
        setTimeout(() => {
          setShowMessageErr(false);
        }, 3000);
        // console.log(e)
      }
    }
    hiddenProductId.current.value = "";
  }

  async function scanMissingProduct(e) {
    e.preventDefault();

    if (
      scannedValue.current.value == "" &&
      !usersIds.includes(getUserIdFromLocalStorage()) &&
      (scannedValue.current.value !== orederProducts[indexProduct]?.bin_id ||
        scannedValue.current.value !== orederProducts[indexProduct]?.upc)
    ) {
      playErrorSound();
      setIsScannedBin(false);
      setMessage(
        " The value of bin or upc scanned is even empty or incorrect !",
      );
      setShowMessageErr(true);
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
    } else {
      const userID = getUserIdFromLocalStorage();

      // const obj = {
      //   order_id: id,
      //   label: hiddenProductId.current.value,
      //   quantity: orederProducts[indexProduct].quantity > 10 ? biggerThanTen.current.value:orederProducts[indexProduct].quantity ,
      //   user_id: userID,
      //   upc: orederProducts[indexProduct]?.upc,
      //   scanned_stand:isScannedBin
      // };
      let labelValue;
      let combined;
      if (orederProducts[indexProduct].option.code) {
        labelValue = orederProducts[indexProduct].option.code;
      } else {
        labelValue = orederProducts[indexProduct].code;
      }

      combined = orederProducts[indexProduct].combined_product;

      const obj = {
        // order_id: id,
        label: labelValue,
        quantity:
          orederProducts[indexProduct].quantity > 10
            ? biggerThanTen.current.value
            : 1,
        user_id: userID,
        scanned_stand: isScannedBin,
        ...(combined ? { combined_product: combined } : {}),
        // Add bin_id, upc, or big_upc based on the conditions
        ...(orederProducts[indexProduct]?.bin_id
          ? { bin_id: orederProducts[indexProduct]?.bin_id }
          : orederProducts[indexProduct]?.upc
            ? { upc: orederProducts[indexProduct]?.upc }
            : orederProducts[indexProduct]?.big_upc
              ? { big_upc: orederProducts[indexProduct]?.big_upc }
              : {}),
      };

      if (type == "normal") {
        obj.order_id = id;
      } else {
        obj.return_order_id = id;
      }

      try {
        let url = "";
        if (type == "normal") {
          url = buildLink("missingPickupOrderProduct");
        } else {
          url = buildLink("missingPickupReturnOrderProduct");
        }
        const queryParams = new URLSearchParams(obj).toString();
        await axiosServer.post(url + "&" + queryParams).then((res) => {
          console.log(res.data);
          if (indexProduct == orederProducts.length - 1) {
            setDisable(true);
          }
          if (res?.data?.success) {
            playSuccessSound();
            setMessage(res?.data?.message);
            setShowMessageSucc(true);
            setTimeout(() => {
              setShowMessageSucc(false);
            }, 3000);
          } else {
            playErrorSound();
            setNext(false);
            setMessage(res?.data?.message);
            setShowMessageErr(true);
            setTimeout(() => {
              setShowMessageErr(false);
            }, 3000);
          }
        });
      } catch (e) {
        playErrorSound();
        setNext(false);
        setMessage(e.response.data.message);
        setShowMessageErr(true);
        setTimeout(() => {
          setShowMessageErr(false);
        }, 3000);
      }
    }
    hiddenProductId.current.value = "";
  }

  useEffect(() => {
    const handleBinFocus = () => {
      setHasBinFocus(document.activeElement === scannedValue.current);
    };

    const handleBinBlur = () => {
      setHasBinFocus(false);
    };
    const handleProductFocus = () => {
      setHasproductFocus(document.activeElement === hiddenProductId.current);
    };

    const handleProductBlur = () => {
      setHasproductFocus(false);
    };
    if (scannedValue.current) {
      scannedValue.current.addEventListener("focus", handleBinFocus);
      scannedValue.current.addEventListener("blur", handleBinBlur);
    }
    if (hiddenProductId.current) {
      hiddenProductId.current.addEventListener("focus", handleProductFocus);
      hiddenProductId.current.addEventListener("blur", handleProductBlur);
    }

    return () => {
      if (scannedValue.current) {
        scannedValue.current.removeEventListener("focus", handleBinFocus);
        scannedValue.current.removeEventListener("blur", handleBinBlur);
      }
      if (hiddenProductId.current) {
        hiddenProductId.current.removeEventListener("focus", handleProductBlur);
        hiddenProductId.current.removeEventListener("blur", handleProductBlur);
      }
    };
  }, [scannedValue, hiddenProductId]);

  useEffect(() => {
    const pressButtonIfNeeded = () => {
      if (
        orederProducts &&
        (productsPickedd[indexProduct] ||
          orederProducts[indexProduct]?.picked) &&
        indexProduct !== orederProducts.length - 1
      ) {
        //to automatically click the button
        document.getElementById("nextButton").click();
      }
    };

    pressButtonIfNeeded();
  }, [orederProducts, indexProduct, productsPickedd]);

  return (
    <>
      <form
        className=" fixed left-[900px]"
        onSubmit={(e) => {
          checkShelfLabel(e);
        }}
      >
        <input ref={scannedValue} />
      </form>

      <form
        className=" fixed left-[900px]"
        onSubmit={(e) => {
          scanProduct(e);
        }}
      >
        {" "}
        <input ref={hiddenProductId} />
      </form>

      {/* header */}
      <div className="  sticky top-0 flex flex-col bg-white z-50">
        <div className=" w-full flex flex-row justify-between  bg-dbase h-16">
          <div className=" container flex relative gap-7 flex-row justify-start w-full text-white  h-full my-auto">
            <button onClick={() => history(-1)}>
              <FaArrowLeft />
            </button>
            <h2 className=" text-xl my-auto"> Scan PickUp Order</h2>
          </div>
        </div>
      </div>
      <div className="w-full h-16 transition-all duration-300 relative overflow-hidden bg-white flex justify-center items-center text-xl font-bold gap-6 px-4">
        <span className="flex items-center gap-2 text-dgreen">
          <FaCheckCircle className="my-auto" />
          Picked: {productsPicked}
        </span>
        <div className="h-8 w-0.5 bg-dgreyBlack"></div>
        <span className="flex items-center gap-2 text-dbase">
          <TbCircleXFilled className="text-2xl my-auto" />
          Not picked: {productsNotPicked}
        </span>
      </div>

      {orederProducts && (
        <>
          {" "}
          <div className=" relative flex flex-col  pb-28    gap-2">
            <button
              disabled={isScannedBin || productsPickedd[indexProduct]}
              onClick={() => scannedValue.current.focus()}
              className={` ${
                isScannedBin || productsPickedd[indexProduct]
                  ? " bg-dgreen2"
                  : "bg-white"
              }  text-dblackk flex flex-row  w-full justify-center  text-3xl   py-2  shadow-md `}
            >
              {" "}
              <>
                {" "}
                Scan <strong>{storeType}</strong>
              </>
              <span
                class={`relative ${
                  hasbinFocus ? "opacity-100" : "opacity-0"
                } transition-all  flex h-3 w-3`}
              >
                <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-dbase opacity-75"></span>
                <span class="relative inline-flex rounded-full h-3 w-3  bg-dbase1"></span>
              </span>
            </button>

            {orederProducts[indexProduct]?.bin_id ? (
              <div className=" w-full shadow-md shadow-dbluegray text-center  flex flex-row justify-between  py-3   ">
                <h2 className=" bg-white w-full  font-bold text-3xl ">
                  {orederProducts[indexProduct]?.floor_name}
                </h2>
                <h2 className=" bg-white w-full  font-bold text-3xl ">
                  {orederProducts[indexProduct]?.stand_name}
                </h2>
                <h2
                  className={`${
                    orederProducts[indexProduct]?.bin_color
                      ? `bg-[${orederProducts[indexProduct]?.bin_color}]`
                      : "bg-white"
                  }  w-full   font-bold text-3xl `}
                >
                  {orederProducts[indexProduct]?.bin_name}
                </h2>
              </div>
            ) : (
              <div className=" w-full shadow-md shadow-dbluegray text-center  flex flex-row justify-between  py-3   ">
                <h2 className=" bg-white w-full  font-bold text-3xl ">
                  {storeTypeVal}
                </h2>
              </div>
            )}
            <div
              onClick={(e) => {
                if (!e.target.matches("input")) {
                  hiddenProductId.current.focus();
                }
              }}
              className={` ${productsPickedd[indexProduct] && "bg-dgreen2"} flex flex-row gap-2 mt-10 justify-start`}
            >
              <div className="  w-[300px] overflow-hidden relative p-3">
                <img
                  className=" relative object-cover w-full h-full"
                  src={orederProducts[indexProduct]?.mobile_image}
                />
              </div>

              <div className=" flex justify-center flex-col gap-1">
                <div className=" justify-start text-left gap-3 flex flex-row ">
                  <h2 className=" w-fit font-bold text-[0.9rem] lg:text-lg bg-dplaceHolder px-4">
                    {orederProducts[indexProduct]?.sku}
                  </h2>
                  <h2 className=" w-fit font-bold text-[0.8rem] lg:text-lg  bg-dplaceHolder px-4">
                    Total Qty : {orederProducts[indexProduct]?.total_quantity}
                  </h2>
                  <span
                    class={`relative ${
                      hasproductFocus ? "opacity-100" : "opacity-0"
                    } transition-all  flex h-3 w-3`}
                  >
                    <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-dbase opacity-75"></span>
                    <span class="relative inline-flex rounded-full h-3 w-3  bg-dbase1"></span>
                  </span>
                </div>
                <h2 className="">{orederProducts[indexProduct]?.name}</h2>
                {orederProducts[indexProduct]?.option.name && (
                  <h2 className=" flex flex-row justify-start text-start gap-2">
                    <strong>
                      {orederProducts[indexProduct]?.option?.name}
                    </strong>
                    <span>{orederProducts[indexProduct]?.option?.value}</span>
                  </h2>
                )}
                <div className=" flex flex-row justify-start gap-4">
                  <h2 className=" text-dgreen">
                    <span>Qty</span>{" "}
                    <strong>{orederProducts[indexProduct]?.quantity}</strong>
                  </h2>
                  {productsPickedd[indexProduct] ? (
                    <h2 className=" text-dgreen">Product Picked</h2>
                  ) : (
                    <h2 className=" text-dbase">
                      <span>Scanned Value</span> <strong>{counter}</strong>
                    </h2>
                  )}
                </div>
                {orederProducts[indexProduct]?.quantity > 10 && (
                  <div className=" flex flex-row justify-start gap-2">
                    <label>Qty</label>
                    <input
                      type="number"
                      ref={biggerThanTen}
                      className="border w-16 border-dhotPink text-center rounded-lg  "
                    />
                  </div>
                )}
              </div>

              {show && splitScanProgress?.remainingPackages > 0 && (
                <div className="mt-2">
                  <div className="p-1">Scanned:</div>
                  <div className="space-x-3 flex flex-wrap">
                    <input
                      value={`${splitScanProgress.checkedPackages}/${splitScanProgress.totalPackages}`}
                      readOnly
                      type="text"
                      className="border mb-3 border-dlabelColor outline-dbase w-full rounded-md py-3 pr-8 pl-2 bg-[#f2f2f2]"
                      placeholder="Scanned"
                    />
                  </div>
                </div>
              )}
            </div>
            <div className=" flex justify-between container  mt-10   py-2 ">
              <button
                disabled={!indexProduct > 0}
                onClick={() => {
                  if (indexProduct > 0) {
                    setindexProduct(indexProduct - 1);
                  } else {
                    // history(-1);
                  }
                }}
                className={` rounded-full  ${
                  indexProduct > 0 ? " bg-dbase" : "bg-dgrey1"
                } p-2 text-white `}
              >
                <FaFastBackward className=" text-black" />
              </button>
              {!missing && (
                <button
                  disabled={disable}
                  onClick={(e) => {
                    scanMissingProduct(e);
                    if (indexProduct !== orederProducts.length - 1) {
                      setindexProduct(indexProduct + 1);
                    }
                  }}
                  className={` rounded-full   bg-dbase p-2 text-white ${
                    disable ? " bg-dgrey1" : "bg-dbase"
                  } `}
                >
                  Missing Item
                </button>
              )}

              <button
                disabled={indexProduct == orederProducts.length - 1}
                onClick={() => {
                  if (indexProduct !== orederProducts.length - 1) {
                    setindexProduct(indexProduct + 1);
                  } else {
                    // history(-1);
                  }
                }}
                className={` rounded-full  ${
                  indexProduct !== orederProducts.length - 1
                    ? " bg-dbase"
                    : "bg-dgrey1"
                } p-2 text-white `}
              >
                <FaFastForward className="  text-black" />
              </button>
            </div>
          </div>
          <button
            id="nextButton"
            onClick={() => {
              if (
                productsPickedd[indexProduct] ||
                orederProducts[indexProduct].picked
              ) {
                if (indexProduct !== orederProducts.length - 1) {
                  setindexProduct(indexProduct + 1);
                } else if (areAllProductsPicked(productsPickedd)) {
                  history(-1);
                } else {
                  const firstUnpickedProductIndex =
                    findNextUnpickedProductIndex(productsPickedd, 0);

                  if (firstUnpickedProductIndex !== -1) {
                    setindexProduct(firstUnpickedProductIndex);
                  }
                }
              }
            }}
            className={`${
              productsPickedd[indexProduct] ||
              orederProducts[indexProduct]?.picked
                ? "bg-dbase text-white"
                : "bg-dplaceHolder text-dblack"
            } w-full py-3 font-semibold px-5 fixed bottom-0 left-0 right-0 flex flex-row gap-3 justify-center text-md mt-10`}
          >
            {indexProduct !== orederProducts.length - 1 ? (
              <>
                <div className="flex flex-row justify-between text-center w-full">
                  <span>Next Product</span>
                  <div className="flex flex-row justify-end gap-4">
                    {orederProducts[indexProduct + 1]?.address ? (
                      <>Address: {orederProducts[indexProduct + 1]?.address}</>
                    ) : (
                      <>
                        UPC:{" "}
                        {orederProducts[indexProduct + 1]?.bin_id
                          ? orederProducts[indexProduct + 1]?.bin_id
                          : orederProducts[indexProduct + 1]?.upc
                            ? orederProducts[indexProduct + 1]?.upc
                            : orederProducts[indexProduct + 1]?.big_upc ||
                              "N/A"}
                      </>
                    )}
                    <FaArrowRight className="my-auto" />
                  </div>
                </div>
              </>
            ) : (
              <span>Finish</span>
            )}
          </button>
        </>
      )}

      <MessageAlert
        message={message}
        type={showMessgErr ? "err" : "succ"}
        showMessg={showMessgErr || (showMessgSucc && true)}
      />
    </>
  );
};

export default ScanPickUpOrderv2;
